import { createModel, RematchDispatch } from '@rematch/core';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { fetchFloorsCms } from '../../services/floor';

export const storeName = 'floorEntity';

export const floorEntity = createModel<RootModel>()({
  name: storeName,
  state: { codes: {} },
  reducers: { ...baseEntity },
  effects: (dispatch: RematchDispatch<typeof floorEntity>) => ({
    async fetchFloor(payload) {
      const resp = await fetchFloorsCms(payload);
      if (!resp) return null;
      const { data } = resp;
      this.saves(data.content);
      return resp;
    },
  }),
});

export default floorEntity;
